"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const arrayMaker_1 = __importDefault(require("../../../../Util/arrayMaker"));
const measurementItemMaker_1 = __importDefault(require("../Maker/measurementItemMaker"));
const getInitialHeightIterator_1 = __importDefault(require("../Maker/getInitialHeightIterator"));
const getInitialBreastIterator_1 = __importDefault(require("../Maker/getInitialBreastIterator"));
const getInitialWaistIterator_1 = __importDefault(require("../Maker/getInitialWaistIterator"));
const getInitialLegsIterator_1 = __importDefault(require("../Maker/getInitialLegsIterator"));
const getInitialShouldersIterator_1 = __importDefault(require("../Maker/getInitialShouldersIterator"));
const getInitialWeightIterator_1 = __importDefault(require("../Maker/getInitialWeightIterator"));
const getHeightProgressIterator_1 = __importDefault(require("../Maker/getHeightProgressIterator"));
const getBreastProgressIterator_1 = __importDefault(require("../Maker/getBreastProgressIterator"));
const getWaistProgressIterator_1 = __importDefault(require("../Maker/getWaistProgressIterator"));
const getLegsProgressIterator_1 = __importDefault(require("../Maker/getLegsProgressIterator"));
const getShouldersProgressIterator_1 = __importDefault(require("../Maker/getShouldersProgressIterator"));
const getWeightProgressIterator_1 = __importDefault(require("../Maker/getWeightProgressIterator"));
const getSkippedWeekMeasurementsIterator_1 = __importDefault(require("../Maker/getSkippedWeekMeasurementsIterator"));
const getTimeIterator_1 = __importDefault(require("../Maker/getTimeIterator"));
class MeasurementsInitializer extends AbstractInitializer_1.default {
    constructor(cache, measurementsModel, customerRepository, dateTimeProvider, dateTimeModifier) {
        super("measurements_initializer", cache);
        this.initialize = async () => {
            const initialHeightIterator = (0, getInitialHeightIterator_1.default)();
            const initialBreastIterator = (0, getInitialBreastIterator_1.default)();
            const initialWaistIterator = (0, getInitialWaistIterator_1.default)();
            const initialLegsIterator = (0, getInitialLegsIterator_1.default)();
            const initialShouldersIterator = (0, getInitialShouldersIterator_1.default)();
            const initialWeightIterator = (0, getInitialWeightIterator_1.default)();
            const heightProgressIterator = (0, getHeightProgressIterator_1.default)();
            const breastProgressIterator = (0, getBreastProgressIterator_1.default)();
            const waistProgressIterator = (0, getWaistProgressIterator_1.default)();
            const legsProgressIterator = (0, getLegsProgressIterator_1.default)();
            const shouldersProgressIterator = (0, getShouldersProgressIterator_1.default)();
            const weightProgressIterator = (0, getWeightProgressIterator_1.default)();
            const skippedWeekMeasurementsIterator = (0, getSkippedWeekMeasurementsIterator_1.default)();
            const currentDate = this.dateTimeProvider.currentDate();
            const timeIterator = (0, getTimeIterator_1.default)();
            await (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), async (customer) => {
                const daysDiff = Math.abs(this.dateTimeModifier.daysDiff(customer.subscriptionPeriod.startDate, currentDate)) + 1;
                const fractionDigits = 2;
                let previousHeight = initialHeightIterator
                    .next()
                    .toFixed(fractionDigits);
                let previousBreast = initialBreastIterator
                    .next()
                    .toFixed(fractionDigits);
                let previousWaist = initialWaistIterator.next().toFixed(fractionDigits);
                let previousLeg = initialLegsIterator.next().toFixed(fractionDigits);
                let previousShoulder = initialShouldersIterator
                    .next()
                    .toFixed(fractionDigits);
                let previousWeight = initialWeightIterator
                    .next()
                    .toFixed(fractionDigits);
                const measurementWeeks = (0, arrayMaker_1.default)(Math.ceil(daysDiff / 7), (week) => {
                    previousHeight = (0, measurementItemMaker_1.default)(fractionDigits, previousHeight, heightProgressIterator);
                    previousBreast = (0, measurementItemMaker_1.default)(fractionDigits, previousBreast, breastProgressIterator);
                    previousWaist = (0, measurementItemMaker_1.default)(fractionDigits, previousWaist, waistProgressIterator);
                    previousLeg = (0, measurementItemMaker_1.default)(fractionDigits, previousLeg, legsProgressIterator);
                    previousWeight = (0, measurementItemMaker_1.default)(fractionDigits, previousWeight, weightProgressIterator);
                    previousShoulder = (0, measurementItemMaker_1.default)(fractionDigits, previousShoulder, shouldersProgressIterator);
                    if (skippedWeekMeasurementsIterator.next()) {
                        return null;
                    }
                    const createdAtRaw = this.dateTimeModifier.modifyDays(customer.subscriptionPeriod.startDate, 7 * week) +
                        "T" +
                        timeIterator.next();
                    return {
                        id: createdAtRaw.substr(0, 10),
                        height: previousHeight,
                        breast: previousBreast,
                        waist: previousWaist,
                        legs: previousLeg,
                        shoulders: previousShoulder,
                        weight: previousWeight,
                        week: week + 1,
                        createdAtRaw,
                        createdAt: "",
                        rawPhotos: {
                            photoFront: "https://via.placeholder.com/350x700/0000FF/808080",
                            photoBack: "https://via.placeholder.com/350x700/FFFF00/000000",
                            photoSide: "https://via.placeholder.com/350x700/000000/FFFFFF",
                        },
                    };
                }).filter((measurement) => measurement !== null);
                await this.measurementsModel.setMeasurements(customer.id, measurementWeeks);
            });
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.measurementsModel = measurementsModel;
        this.customerRepository = customerRepository;
    }
}
exports.default = MeasurementsInitializer;
//# sourceMappingURL=MeasurementsInitializer.js.map